import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "./flexproducts";
import Header from "../headers_footer/header";

const Collections = () => {

return (

<div>

<Navbar />
<Flexproducts type="products" />
<Header></Header>

</div>

);
};

export default Collections;